<template>   
  <div class="db center w-100">
    <a class="db absolute right-0 mr1 mt1 grow pointer nav-toggle vid-modal-toggle is-clicked z-9002" style="" @click="$emit('close')">
      <span class="line"></span> 
      <span class="line"></span> 
      <span class="line"></span>
    </a>
    <div class="db center relative">
        <section class="relative mw8 center pv4 pv5-ns tl bg-navy">
          <div class="relative container-fluid">
            <div class="relative center mw6">
              <h2 class="f3 mv3 tc ttu is-lorano-bold is-white">{{title}}</h2>
              <div class="f5 f4-ns lh-copy is-white cms-content">{{text}}</div>
              <div class="f5 f4-ns lh-copy is-white cms-content">{{text}}</div>
            </div>
          </div>
        </section>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        //
      }
    },
    props: ['title','text']
  }
</script>